import { AuditLogRepoImpl } from "domain/repository/AuditLog/AuditLogRepoImpl";
import { MasterDataRepoImpl } from "domain/repository/MasterData/MasterDataRepoImpl";
import { OpsLineRepoImpl } from "domain/repository/OpsLine/OpsLineRepoImpl";
import { UserRepoImpl } from "domain/repository/User/UserRepoImpl";
import { useAuditLogMaintenanceTracked } from "presentation/store/AuditLog/AuditLogMaintenanceProvider";
import { AuditLogMaintenanceVM } from "presentation/viewModel/AuditLog/AuditLogMaintenanceVM";
import { useMemo } from "react";

export const useAuditLogMaintenanceVM = () => {
    const [, setAuditLogMaintenanceState] = useAuditLogMaintenanceTracked();
    const auditLogMainVM = useMemo(() =>
        AuditLogMaintenanceVM({
            dispatch: [setAuditLogMaintenanceState],
            repo: AuditLogRepoImpl(),
            opsLineRepo: OpsLineRepoImpl(),
            masterDataRepo: MasterDataRepoImpl(),
            userRepo: UserRepoImpl(),
        }), [setAuditLogMaintenanceState])

    return auditLogMainVM
}

